const ConfigNavIcon = ({
  className = 'stroke-green-800'
}: {
  className?: string
  fill?: string
}) => (
  <svg
    width='24'
    height='27'
    viewBox='0 0 24 27'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.90007 17.2999L5.29807 17.5363C6.33007 17.7108 7.06707 18.7314 6.99107 19.8812L6.88807 21.4397C6.85807 21.8937 7.08207 22.3211 7.45307 22.5188L8.48707 23.0689C8.85807 23.2666 9.30107 23.1926 9.60407 22.8844L10.6431 21.8241C11.4091 21.0421 12.5911 21.0421 13.3581 21.8241L14.3971 22.8844C14.7001 23.1937 15.1421 23.2666 15.5141 23.0689L16.5501 22.5177C16.9201 22.3211 17.1431 21.8948 17.1131 21.4419L17.0101 19.8812C16.9341 18.7314 17.6711 17.7108 18.7031 17.5363L20.1011 17.2999C20.5081 17.2315 20.8361 16.8946 20.9281 16.4506L21.1831 15.2157C21.2751 14.7717 21.1121 14.3111 20.7721 14.0548L19.6051 13.1723C18.7441 12.5207 18.4811 11.2482 19.0011 10.2486L19.7061 8.8945C19.9111 8.50018 19.8771 8.00646 19.6201 7.6508L18.9051 6.66004C18.6481 6.30439 18.2201 6.15748 17.8261 6.29113L16.4741 6.74841C15.4751 7.08639 14.4101 6.51977 14.0261 5.44727L13.5081 3.99703C13.3561 3.57289 12.9851 3.29455 12.5721 3.29566L11.4261 3.29897C11.0131 3.30008 10.6431 3.58063 10.4931 4.00587L9.98807 5.43954C9.60807 6.51866 8.53807 7.0897 7.53607 6.74951L6.12807 6.27236C5.73307 6.1376 5.30307 6.28561 5.04607 6.64348L4.33607 7.63534C4.07907 7.99431 4.04807 8.48914 4.25707 8.88345L4.97807 10.2409C5.50907 11.2416 5.24907 12.5262 4.38307 13.1812L3.23007 14.0537C2.89007 14.3111 2.72707 14.7717 2.81907 15.2146L3.07407 16.4495C3.16507 16.8946 3.49307 17.2315 3.90007 17.2999V17.2999Z'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.916 11.1555C14.974 12.3241 14.974 14.2194 13.916 15.388C12.858 16.5566 11.142 16.5566 10.084 15.388C9.02603 14.2194 9.02603 12.3241 10.084 11.1555C11.142 9.98691 12.858 9.98691 13.916 11.1555'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default ConfigNavIcon
